import { render } from "./App.vue?vue&type=template&id=55ff9f42"
const script = {}

import "./App.vue?vue&type=style&index=0&id=55ff9f42&lang=css"

import exportComponent from "C:\\files\\vue3_lesson_demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__